import { buildElement, buildBlankElement, buildEmptyElement } from './buildElement'

const buildElements = ({ assignments = [], blanks = [], gaps = [], spaceId, returnTo }) => [
  ...assignments.map(assignment => buildElement(assignment, spaceId, returnTo)),
  ...blanks.map(blank => buildBlankElement(blank, spaceId)),
  ...gaps.map(gap => buildEmptyElement(gap, spaceId, returnTo)),
]

export default buildElements
